// extracted by mini-css-extract-plugin
export default {"content":"RemoveStruct_content__qZkiH","buttonStyle":"RemoveStruct_buttonStyle__jQBC5","sizeText16":"RemoveStruct_sizeText16__3qabn"};